import { workflowAxiosGet } from "../utils/workflowAuthHeaders";

const BASE_URL = "https://workflow.grupocenze.com.br:38137/rest/";

/** GET INT_CRM_APP_VENDEDORES — lista de vendedores */
const fetchVendedoresCrm = async ({
  empresa = "01",
  filial = "01",
  token,
  username,
  password,
} = {}) => {
  try {
    const response = await workflowAxiosGet(
      `${BASE_URL}INT_CRM_APP_VENDEDORES`,
      {
        params: {
          empresa,
          filial,
        },
      },
      { token, username, password }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar vendedores (CRM):", error);
    throw error;
  }
};

export default fetchVendedoresCrm;
